// src/layouts/BaseLayout.tsx
import { Footer } from '@/components/common/Footer';
import { Navbar } from '@/components/common/Navbar';
import React from 'react';
import { Outlet } from 'react-router-dom';

const BaseLayout = () => {
  return (
    <div className="font-openSans flex w-full justify-center">
      <div className="flex w-full flex-wrap justify-center">
        <Navbar />

        {/* Main content */}
        <Outlet />

        <Footer />
      </div>
    </div>
  );
};

export default BaseLayout;
